import React, { useContext, useEffect, useState } from "react";
// Soft UI Dashboard PRO React example components
import { useNavigate } from "react-router-dom";

import SuiButton from "components/SuiButton";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Avatar from "@mui/material/Avatar";
import Tooltip from "@mui/material/Tooltip";

import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";

// Soft UI Dashboard PRO React components
import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";
import Skeleton from "@mui/material/Skeleton";

import { StoreContext } from "context/store";
import { AccountContext } from "context/account";
import CategoryContext from "context/category-context";

import ImportSingleStyleModal from "pages/de/portfolio/components/ImportSingleStyleModal";
import UploadProfileModal from "pages/de/portfolio/components/UploadProfileModal";
import ImportSingleCollectionModal from "pages/de/portfolio/components/ImportSingleCollectionModal";
import AddProductCard from "pages/de/portfolio/components/AddProductCard";
import ProductCard from "pages/de/portfolio/components/ProductCard";

import api from "services/api";

import toast from "react-hot-toast";
import SortableList, { SortableItem } from "react-easy-sort";
import Masonry, { ResponsiveMasonry } from "react-responsive-masonry";
import { Empty } from "antd";
import ProductDetailModal from "pages/de/portfolio/components/ProductDetailModal";

const FeaturedStyleList = ({ handle, handleRefresh, handleOk, onSortEnd, userData }) => {
  const [productDetailVisible, setProductDetailVisible] = useState();
  const [selectedProductId, setSelectedProductId] = useState(false);
  const { store } = useContext(StoreContext);
  const account = useContext(AccountContext);

  let portfolioData = account?.metadata?.portfolio_content || {};
  let storeData = store;
  if (handle) {
    portfolioData = userData?.metadata?.portfolio_content || {};
    storeData = userData?.stores?.[0] || {};
  }
  let styleList = portfolioData["style_0"] || [];

  const handleClickProduct = (product) => {
    setSelectedProductId(product?.id);
    setProductDetailVisible(true);
  };

  return (
    <SuiBox>
      {styleList.length > 0 ? (
        <ResponsiveMasonry columnsCountBreakPoints={{ 250: 1, 650: 2, 1050: 3, 1400: 4 }}>
          <Masonry>
            {styleList.map((p, index) => (
              <SuiBox key={index}>
                <div
                  className="mx-2 my-2"
                  style={{
                    overflow: "hidden",
                  }}
                >
                  <ProductCard
                    index={index}
                    product={p}
                    imageOnly={true}
                    handleClick={() => handleClickProduct(p)}
                    editable={handle ? false : true}
                    slot="style_0"
                    handleRefresh={handleRefresh}
                    height={260}
                    width={240}
                    sx={{ height: 260, width: "auto", maxHeight: 320 }}
                  />
                </div>
              </SuiBox>
            ))}{" "}
          </Masonry>
        </ResponsiveMasonry>
      ) : (
        <SuiBox my={4}>
          <Empty />
        </SuiBox>
      )}

      {productDetailVisible && selectedProductId ? (
        <ProductDetailModal
          visible={productDetailVisible}
          handleClose={() => setProductDetailVisible(false)}
          productId={selectedProductId}
        />
      ) : null}
    </SuiBox>
  );
};

export default FeaturedStyleList;
